'use es6';

import { FETCH_BLOG_LIMIT_FAILED, FETCH_BLOG_LIMIT_SUCCEEDED, FETCH_BLOG_LIMIT_STARTED, FETCH_BLOG_POST_LIMIT_FAILED, FETCH_BLOG_POST_LIMIT_SUCCEEDED, FETCH_BLOG_POST_LIMIT_STARTED, FETCH_MLANG_BLOG_POST_LIMIT_FAILED, FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED, FETCH_MLANG_BLOG_POST_LIMIT_STARTED } from './actionTypes';
import BlogLimitApi from '../../api/BlogLimitApi';
import BlogPostLimitApi from '../../api/BlogPostLimitApi';

// REQUEST FAILURES ---------------------->

const fetchBlogLimitFailed = error => {
  return {
    type: FETCH_BLOG_LIMIT_FAILED,
    payload: error
  };
};
const fetchBlogPostLimitFailed = error => {
  return {
    type: FETCH_BLOG_POST_LIMIT_FAILED,
    payload: error
  };
};
const fetchMlangBlogPostLimitFailed = error => {
  return {
    type: FETCH_MLANG_BLOG_POST_LIMIT_FAILED,
    payload: error
  };
};

// REQUEST SUCCESSES --------------------->

const fetchBlogLimitSucceeded = limit => {
  return {
    type: FETCH_BLOG_LIMIT_SUCCEEDED,
    payload: limit
  };
};
const fetchBlogPostLimitSucceeded = limit => {
  return {
    type: FETCH_BLOG_POST_LIMIT_SUCCEEDED,
    payload: limit
  };
};
const fetchMlangBlogPostLimitSucceeded = limit => {
  return {
    type: FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED,
    payload: limit
  };
};

// REQUESTS ------------------------------>

export const fetchBlogLimit = () => dispatch => {
  dispatch({
    type: FETCH_BLOG_LIMIT_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchBlogLimitSucceeded(resp));
    } else {
      dispatch(fetchBlogLimitFailed(resp));
    }
  };
  const error = resp => dispatch(fetchBlogLimitFailed(resp));
  BlogLimitApi.fetch().then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchBlogPostLimit = () => dispatch => {
  dispatch({
    type: FETCH_BLOG_POST_LIMIT_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchBlogPostLimitSucceeded(resp));
    } else {
      dispatch(fetchBlogPostLimitFailed(resp));
    }
  };
  const error = resp => dispatch(fetchBlogPostLimitFailed(resp));
  BlogPostLimitApi.fetch().then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};
export const fetchMlangBlogPostLimit = contentId => dispatch => {
  dispatch({
    type: FETCH_MLANG_BLOG_POST_LIMIT_STARTED
  });
  const success = resp => {
    if (resp) {
      dispatch(fetchMlangBlogPostLimitSucceeded(resp));
    } else {
      dispatch(fetchMlangBlogPostLimitFailed(resp));
    }
  };
  const error = resp => dispatch(fetchMlangBlogPostLimitFailed(resp));
  BlogPostLimitApi.fetchMlangLimit(contentId).then(success, error).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};